import api from '../../../App/socket';

export const getLeadFinance = (params) => {
    const { leadId } = params;

    return api.send({
        api: 'db',
        model: 'Lead_finance',
        action: 'Read',
        options: {
            attributes: 'all',
            where: {
                ref_lead: leadId,
            },
            include: [
                {
                    model: 'User',
                    path: 'bought_info.purchasing_team_approval.updated_by',
                    attributes: ['person.first_name', 'person.last_name'],
                },
                {
                    model: 'User',
                    path: 'bought_info.transport_team_approval.updated_by',
                    attributes: ['person.first_name', 'person.last_name'],
                },
                {
                    model: 'User',
                    path: 'bought_info.accounts_team_approval.updated_by',
                    attributes: ['person.first_name', 'person.last_name'],
                },
                {
                    model: 'User',
                    path: 'bought_info.bought_by_driver',
                    attributes: ['person.first_name', 'person.last_name'],
                },
                {
                    model: 'Lead',
                    path: 'ref_lead',
                    attributes: ['valuations.valuation'],
                },
                {
                    model: 'Files',
                    path: 'settlement_proof',
                    attributes: 'all',
                },
            ],
            limit: 1,
        },
    }).then((res) => res).catch((res) => res);
};

export const saveLeadFinance = (params) => {
    const { data, op, finId } = params;

    return api.send({
        api: 'db',
        model: 'Lead_finance',
        action: op,
        options: {
            create: op === 'Create' && data,
            update: op === 'Update' && data,
            where: op === 'Update' && { _id: finId },
        },
    }).then((res) => res).catch((res) => res);
};



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/requests/leadFinance.requests.js